interface GaugeChartProps {
  value: number
  maxValue?: number
  label?: string
}

export function GaugeChart({ value, maxValue = 100, label = 'Impact Rating' }: GaugeChartProps) {
  const percentage = (value / maxValue) * 100

  // Create segments for the circular gauge
  const totalSegments = 40
  const filledSegments = Math.round((percentage / 100) * totalSegments)
  const segmentAngle = 360 / totalSegments
  const gapAngle = 3 // Gap between segments

  return (
    <div className='flex flex-col items-center'>
      <div className='relative w-[200px] h-[200px]'>
        <svg viewBox='0 0 200 200' className='w-full h-full transform -rotate-90'>
          {/* Background segments */}
          {Array.from({ length: totalSegments }).map((_, i) => {
            const startAngle = i * segmentAngle
            const endAngle = startAngle + segmentAngle - gapAngle
            const isFilled = i < filledSegments

            // Determine color based on position and fill status
            let color = '#E5E7EB' // Default gray
            if (isFilled) {
              // Gradient from light orange to dark orange based on position
              const progress = i / totalSegments
              if (progress < 0.33) {
                color = '#FED7AA' // Light orange
              } else if (progress < 0.66) {
                color = '#FB923C' // Medium orange
              } else {
                color = '#F97316' // Dark orange
              }
            }

            const startRad = (startAngle * Math.PI) / 180
            const endRad = (endAngle * Math.PI) / 180
            const innerRadius = 70
            const outerRadius = 90

            const x1 = 100 + Math.cos(startRad) * innerRadius
            const y1 = 100 + Math.sin(startRad) * innerRadius
            const x2 = 100 + Math.cos(startRad) * outerRadius
            const y2 = 100 + Math.sin(startRad) * outerRadius
            const x3 = 100 + Math.cos(endRad) * outerRadius
            const y3 = 100 + Math.sin(endRad) * outerRadius
            const x4 = 100 + Math.cos(endRad) * innerRadius
            const y4 = 100 + Math.sin(endRad) * innerRadius

            return (
              <path
                key={i}
                d={`M ${x1} ${y1} L ${x2} ${y2} A ${outerRadius} ${outerRadius} 0 0 1 ${x3} ${y3} L ${x4} ${y4} A ${innerRadius} ${innerRadius} 0 0 0 ${x1} ${y1} Z`}
                fill={color}
              />
            )
          })}
        </svg>

        {/* Center text */}
        <div className='absolute inset-0 flex flex-col items-center justify-center'>
          <p className='text-[14px] text-[#4e4d4d] font-normal leading-6'>{label}</p>
          <p className='text-[40px] font-bold text-[#151515] leading-[48px] tracking-[-0.5px]'>{value}%</p>
        </div>
      </div>
    </div>
  )
}
